<osp-icon
  [ospTooltip]="tooltipText"
  [tooltipPosition]="tooltipPosition"
  [icon]="IconKey.GlobalInfo | icon"
  iconWeight="bold"
  iconColor="text-secondary"
  [iconSize]="iconSize"
/>
